// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3d7iS","left":"styles_left__14Ofx","desktopActions":"styles_desktopActions__bQWq5","title":"styles_title__2CrqH"};